/*
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2020-12-23 15:02:55
 * @LastEditTime: 2020-12-29 16:14:00
 */
import vue from "vue";
import dialog from "./dialog";
import i18n from "../../i18n";

// 组件构造器，构造出一个 vue组件实例
const DialogConstructor = vue.extend(dialog);

function Message({ title, content, type, time, btn, onClose, showCancelBtn }) {
    const DialogDom = new DialogConstructor({
        el: document.createElement("div"),
        data() {
            return {
                visible: true, // 组件可见
                title: title || '', // 标题
                type: type || 1, // 类型： 1-提示、2-confirm窗、3-多按钮弹窗、4-加载动画
                btn: btn || [i18n.t("toast.confirm_bth_text")],
                showCancelBtn: showCancelBtn || false,
                cancel_btn_text: i18n.t("toast.cancel_bth_text"),
                content: content,
                onClose: onClose || null,
                time: time || 1500,
            };
        },
        methods: {
            // 关闭
            close(index) {
                this.visible = false;
                DialogDom.$el.remove();
                onClose && onClose(index);
            },
            auto() {
                setTimeout(() => {
                    this.close();
                }, this.time);
            },
        },
        created() {
            if (this.type == 1 || this.type == 4) {
                this.auto();
            }
        },
    });
    // 添加节点
    document.body.appendChild(DialogDom.$el);
}

export default Message;
